/**
 * Sign-time check for "[ ]" placeholders left from an inserted AI draft. The backend's
 * validate-submit only sets placeholderMessage when an AI draft was inserted for the study and
 * placeholders remain, so reports that never had an AI draft are never prompted.
 *
 * @returns the confirmation text to show, or null to carry on signing
 */
export const aiPlaceholderPromptMessage = (preCheckData, alreadyAccepted) => {
  const message = preCheckData?.placeholderMessage;
  return message && !alreadyAccepted ? message : null;
};
